var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinux(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.38 152.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-559.91 -413.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path954",
    d: "m713.68 508.66",
    style: {
      stroke: "#000000",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path956",
    d: "m586.4 430.34 15-15h50l15 15v120h-80z",
    style: {
      fillRule: "evenodd",
      stroke: "#7d7d7d",
      strokeMiterlimit: 10,
      strokeWidth: 3.75,
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path958",
    d: "m593.9 432.84 12.5-12.5h40l12.5 12.5z",
    style: {
      fillRule: "evenodd",
      stroke: "#9c9c9c",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "#bdbdbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path960",
    d: "m595.15 435.34h62.5c0.6885 0 1.25 0.55663 1.25 1.25v107.5c0 0.6885-0.5615 1.25-1.25 1.25h-62.5c-0.69325 0-1.25-0.5615-1.25-1.25v-107.5c0-0.69337 0.55675-1.25 1.25-1.25",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#9c9c9c",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "#bdbdbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path962",
    d: "m600.15 442.84h52.5c0.6885 0 1.25 0.55663 1.25 1.25v12.5c0 0.68848-0.5615 1.25-1.25 1.25h-52.5c-0.69325 0-1.25-0.56152-1.25-1.25v-12.5c0-0.69337 0.55675-1.25 1.25-1.25",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#7d7d7d",
      strokeMiterlimit: 10,
      strokeWidth: 3.75,
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path964",
    d: "m600.15 465.34h52.5c0.6885 0 1.25 0.55665 1.25 1.25v12.5c0 0.68848-0.5615 1.25-1.25 1.25h-52.5c-0.69325 0-1.25-0.56152-1.25-1.25v-12.5c0-0.69337 0.55675-1.25 1.25-1.25",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#7d7d7d",
      strokeMiterlimit: 10,
      strokeWidth: 3.75,
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path966",
    d: "m622.65 492.84h30c0.6885 0 1.25 0.55663 1.25 1.25v10c0 0.6885-0.5615 1.25-1.25 1.25h-30c-0.69325 0-1.25-0.5615-1.25-1.25v-10c0-0.69337 0.55675-1.25 1.25-1.25",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#7d7d7d",
      strokeMiterlimit: 10,
      strokeWidth: 3.75,
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path968",
    d: "m613.9 499.09c0 8.335-12.5 8.335-12.5 0s12.5-8.335 12.5 0",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#7d7d7d",
      strokeMiterlimit: 10,
      strokeWidth: 2.5,
      fill: "#c51900"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path970",
    d: "m611.4 516.65h5v27.5h-5z",
    style: {
      fillRule: "evenodd",
      stroke: "#7d7d7d",
      strokeMiterlimit: 10,
      strokeWidth: 2.5,
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path972",
    d: "m621.4 516.65h5v27.5h-5z",
    style: {
      fillRule: "evenodd",
      stroke: "#7d7d7d",
      strokeMiterlimit: 10,
      strokeWidth: 2.5,
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path974",
    d: "m631.4 516.65h5v27.5h-5z",
    style: {
      fillRule: "evenodd",
      stroke: "#7d7d7d",
      strokeMiterlimit: 10,
      strokeWidth: 2.5,
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path976",
    d: "m641.4 516.65h5v27.5h-5z",
    style: {
      fillRule: "evenodd",
      stroke: "#7d7d7d",
      strokeMiterlimit: 10,
      strokeWidth: 2.5,
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path978",
    d: "m651.4 516.7h5v27.5h-5z",
    style: {
      fillRule: "evenodd",
      stroke: "#7d7d7d",
      strokeMiterlimit: 10,
      strokeWidth: 2.5,
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path980",
    d: "m569.65 535.42 2.7197-4.3848 6.9971-10.64-0.05-15.869 0.39075-1.5186 0.72275-1.0302 1.2745-1.4502 1.5185-1.3086 1.2012-0.8838 1.9825-0.60058h1.5185l1.626 0.0342 1.7335 0.35158 1.9092 0.8496 1.6602 0.8496 1.4112 1.2744 1.0988 1.377 1.1328 1.8701 0.49325 1.9825 0.175 2.7246 0.25 4.7022 0.035 3.4277 3.0078 3.9942 4.5947 6.5772 2.6465 4.9854 1.3478 3.2861 0.3075 3.1152-0.1475 2.2022-0.23 2.1045-0.83975 3.5156-0.8595 2.3192-8.877 13.291-6.3623-1.9092-10.249 0.035-3.6426 2.4072-9.1553-14.99-2.7588-4.6338-0.1425-2.4365 0.36125-2.5781z",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path982",
    d: "m584.92 511.27c0 4.541-4.4922 4.541-4.4922 0 0-4.5361 4.4922-4.5361 4.4922 0",
    style: {
      fillRule: "evenodd",
      stroke: "#ffffff",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path984",
    d: "m581.19 521.59 0.4345-4.0332 12.427-1.4892 0.21 2.9443 1.3232 2.5146 0.9325 2.0898 1.7675 3.7598 0.996 2.0508 1.001 1.9532 0.6055 1.958 0.65425 3.3887 0.1525 3.6279 0.1575 4.7852-1.7628 5.9473-2.915 2.3145-1.6358 1.4015-2.378 1.5772-2.08 1.0692-1.87 0.503-2.0752 0.27825-1.7432-0.0575-2.5098-0.16-1.3085-0.708-1.0692-0.90325-1.7432-2.1092h1.2598l1.0548-0.41025 0.59575-0.6885 0.205-1.0352-0.41025-1.1182-5.1562-4.6094-2.0312-2.8906-0.713-1.8165 0.005-1.5478 0.6835-3.0322 1.3672-3.3594 1.4648-3.3545 1.5088-3.4228 1.4942-2.876z",
    style: {
      fillRule: "evenodd",
      stroke: "#ffffff",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path986",
    d: "m594.04 511.73c0 6.1475-5.9522 6.1475-5.9522 0 0-6.1426 5.9522-6.1426 5.9522 0",
    style: {
      fillRule: "evenodd",
      stroke: "#ffffff",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path988",
    d: "m592.43 512.16c0 2.9199-3.1396 2.9199-3.1396 0 0-2.9248 3.1396-2.9248 3.1396 0",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path990",
    d: "m580.56 517.21 0.0575-1.2012 1.3965-0.90325 1.748-1.46 1.2988-0.6495 1.006-0.23 1.455 0.1325 1.6552 0.6495 2.4318 0.97175 2.9932 1.206-0.72275 1.8262-2.1388 1.3428-1.8165 1.2352-1.7188 0.97175-1.7822 0.3565-0.747-0.0625-1.914-1.0058-1.421-1.3622-1.4942-1.2988z",
    style: {
      fillRule: "evenodd",
      stroke: "#ca9c00",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "#ffc200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path992",
    d: "m583.78 512.34c0 2.3878-2.5684 2.3878-2.5684 0 0-2.3828 2.5684-2.3828 2.5684 0",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path994",
    d: "m581.54 518.32 1.1572 0.46375 1.338 0.33701 1.3232 0.0875 1.3478-0.155 2.1532-0.73725 1.338-0.5175 1.0888-0.5175 1.1718-0.7665",
    style: {
      stroke: "#ca9c00",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path996",
    d: "m560.6 559.42 0.245-1.0252 0.46375-1.0595 0.52725-1.0255 0.1425-1.2012-0.21-1.5575-0.28325-1.7675 0.035-2.085 0.18-1.377 0.703-0.46375 1.0595-0.245 1.2402 0.035 1.5528-0.035 1.206-0.8495 0.7765-1.2745 0.75675-1.3575 0.92275-0.4345h0.98625l1.079 0.55175 4.8047 6.8359 2.5635 3.8428 2.1828 3.1592 0.38075 1.582 0.03 1.499-0.2735 1.1865-0.63475 0.8105-0.957 0.63975-1.4842 0.49325-1.7335 0.035-3.0713-0.59575-4.2432-1.4502-4.8438-1.3818-2.5488-0.42475-0.8105-0.21z",
    style: {
      fillRule: "evenodd",
      stroke: "#ca9c00",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "#ffc200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path998",
    d: "m600.2 564.72-1.6455-1.001-0.92275-1.6942-0.235-2.4708 0.69825-2.5049 0.459-2.2362 0.2735-5.127v-3.5059l0.38575-1.3868 1.079-0.3125 1.3868 0.46374v1.3915l0.2685 0.84475 1.1182 0.92776 1.2352 0.537 1.2695 0.2685 1.3915-0.1125 0.962-0.46375 0.92275-0.69325 0.542-1.0058 0.3075-0.92275 0.96675 0.04 0.92275 0.88375 0.38575 2.0068 0.1575 1.1572 0.7325 1.001 1.04 1.1572 1.582 1.04 1.621 1.255-0.46875 1.1768-0.7325 1.1182-2.002 1.3868-1.8115 0.69324-2.4318 1.3525-2.1972 1.7285-3.1982 2.4318-2.1192 0.7715z",
    style: {
      fillRule: "evenodd",
      stroke: "#ca9c00",
      strokeMiterlimit: 10,
      strokeWidth: 1.25,
      fill: "#ffc200"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinux);
export default __webpack_public_path__ + "static/media/linux.58855a9fb1e3ed4b431caaf1e3eaaece.svg";
export { ForwardRef as ReactComponent };